import { Accordion } from '@/components/common/Accordion';
import { Section } from '@/components/common/Section';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import { DiscountRow } from '@/components/dashboard/orders/orders-discount/DiscountRow';
import { OrderHistoryRow } from '@/components/dashboard/orders/orders-history/OrderHistoryRow';
import { ItemsPriceRow } from '@/components/dashboard/orders/orders-items/ItemsPriceRow';
import { PatientCartsRow } from '@/components/dashboard/orders/orders-patient-carts/PatientCartsRow';
import { CreateWalkInOrderRow } from '@/components/dashboard/orders/orders-walk-in/CreateWalkInOrderRow';
import { OrdersRow } from '@/components/dashboard/orders/orders/OrdersRow';
import { Role } from '@/domain/Role';
import { useHasRole } from '@/hooks/useHasRole';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const OrdersPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const { hasRole } = useHasRole();
  const [accordionValue, setAccordionValue] = useState('');

  const canCreateWalkIn = hasRole(Role.SHOP_ADMIN, Role.SUPERADMIN);

  return (
    <Section>
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          value={accordionValue}
          onValueChange={setAccordionValue}
          className="w-full space-y-4 border-none"
        >
          <>
            {canCreateWalkIn && (
              <CreateWalkInOrderRow accordionOpenValue={accordionValue} />
            )}
            {hasRole(Role.SHOP_ADMIN, Role.SUPERADMIN, Role.SALES_MANAGER) && (
              <DiscountRow />
            )}
            {hasRole(
              Role.SHOP_ADMIN,
              Role.SUPERADMIN,
              Role.PACKER,
              Role.SALES_MANAGER,
            ) && <OrdersRow accordionOpenValue={accordionValue} />}

            <OrderHistoryRow accordionOpenValue={accordionValue} />

            {hasRole(
              Role.DOCTOR,
              Role.SHOP_ADMIN,
              Role.SUPERADMIN,
              Role.SALES_MANAGER,
            ) && (
              <>
                <PatientCartsRow accordionOpenValue={accordionValue} />
                <ItemsPriceRow accordionOpenValue={accordionValue} />
              </>
            )}
          </>
        </Accordion>
      </CardsContainer>
    </Section>
  );
};
